import React from 'react';
import PropTypes from 'prop-types';

export default function StepStatic({ title, iconClass }) {
  return (
    <div className="selected-topic icon-with-text">
      <div className="icon-bg bg-tertiary-1000">
        <i className={iconClass} />
      </div>

      <div className="text-content">{title}</div>
    </div>
  );
}

StepStatic.propTypes = {
  title: PropTypes.string.isRequired,
  iconClass: PropTypes.string.isRequired,
};
